import type { SVGProps } from "react";

export function IconFastTime(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="56" height="56" rx="28" fill="#F7F2F2" />
      <g clipPath="url(#clip0_2665_14723)">
        <path
          d="M14 22.6667H22.6667"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="square"
        />
        <path
          d="M14 33.3333H22"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="square"
        />
        <ellipse
          cx="31.3339"
          cy="28"
          rx="9.33333"
          ry="13.3333"
          transform="rotate(15 31.3339 28)"
          fill="#FA7D7D"
          stroke="#FA7D7D"
          strokeWidth="2"
          strokeLinecap="square"
        />
        <path
          d="M33.2305 20.9167L30.9874 29.2881L33.2305 31.3334"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="square"
        />
        <path
          d="M18 28H25.3333"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_2665_14723">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(12 12)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
